module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("74OyS"))).then(() => parcelRequire('hEqeo'));